// Payload dates are Swift `.iso8601`: whole seconds, UTC, `Z` (WEB_PLAN.md §0). iOS 17's decoder rejects fractional
// seconds, so this is the only place that may format a payload date. Envelope times (`modified_at`) keep milliseconds
// and use `toEnvelopeDate`.

/** `2026-09-29T14:03:11Z` (drops milliseconds). */
export function toWireDate(date: Date): string {
  if (!Number.isFinite(date.getTime())) throw new RangeError('Invalid date');
  return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

/** `2026-09-29T14:03:11.123Z` for sync_push `modified_at`. */
export function toEnvelopeDate(date: Date): string {
  if (!Number.isFinite(date.getTime())) throw new RangeError('Invalid date');
  return date.toISOString();
}

/** Parses a payload or envelope date; undefined for a missing or unparseable value. */
export function parseWireDate(value: unknown): Date | undefined {
  if (typeof value !== 'string' || value.length === 0) return undefined;
  const t = Date.parse(value);
  return Number.isFinite(t) ? new Date(t) : undefined;
}
